import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_execution-hub-52/artifacts/f0e2q5kr_40434786-BC05-497A-BBE0-931848E37F84-removebg-preview.png";

const Footer = () => {
    return (
        <footer className="bg-[#040B1A] border-t border-[#C9A14A]/15 mt-24" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <Link to="/" className="flex items-center gap-3">
                            <img src={LOGO} alt="Indravax" className="h-14 w-14 object-contain" />
                            <div className="leading-tight">
                                <div className="font-serif text-2xl text-white tracking-wide">INDRAVAX</div>
                                <div className="text-[0.6rem] tracking-[0.22em] text-[#C9A14A] uppercase">Strategic Advisory LLP</div>
                            </div>
                        </Link>
                        <p className="mt-8 text-sm text-slate-400 max-w-md leading-relaxed font-light">
                            Independent strategic advisory and transaction facilitation across defence, trade,
                            energy, and healthcare — coordinated across global markets.
                        </p>
                        <div className="mt-8 inline-flex items-center gap-3">
                            <span className="h-px w-10 bg-[#C9A14A]" />
                            <span className="text-[0.65rem] tracking-[0.3em] uppercase text-[#C9A14A]">
                                Precision · Power · Partnerships
                            </span>
                        </div>

                        <div className="mt-8 flex items-center gap-3">
                            <a
                                href="https://www.instagram.com/indravax"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Indravax on Instagram"
                                data-testid="footer-instagram"
                                className="inline-flex items-center justify-center w-10 h-10 border border-[#C9A14A]/40 text-[#C9A14A] hover:bg-[#C9A14A] hover:text-[#0A1F44] transition-colors duration-300"
                            >
                                <Instagram size={16} strokeWidth={1.5} />
                            </a>
                            <span className="text-[0.65rem] tracking-[0.25em] uppercase text-slate-500">
                                @indravax
                            </span>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="overline mb-5">Navigate</div>
                        <ul className="space-y-3 text-sm text-slate-400">
                            {["About", "Services", "Sectors", "Trade", "Healthcare", "Legal", "Contact"].map((l) => (
                                <li key={l}>
                                    <Link
                                        to={`/${l.toLowerCase()}`}
                                        className="hover:text-[#C9A14A] transition-colors"
                                        data-testid={`footer-link-${l.toLowerCase()}`}
                                    >
                                        {l}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="overline mb-5">Principal Office</div>
                        <div className="text-sm text-slate-400 space-y-4 font-light">
                            <div className="flex gap-3">
                                <MapPin size={16} className="text-[#C9A14A] mt-1 shrink-0" />
                                <span>17A/55-56, UG-6, Triveni Plaza, WEA, Karol Bagh,<br />New Delhi – 110005, India</span>
                            </div>
                            <div className="flex gap-3">
                                <Phone size={16} className="text-[#C9A14A] shrink-0" />
                                <a href="tel:+917814050036" className="hover:text-[#C9A14A] transition-colors">+91 78140 50036</a>
                            </div>
                            <div className="flex gap-3">
                                <Mail size={16} className="text-[#C9A14A] shrink-0" />
                                <a href="mailto:prateekgrewal@indravax.com" className="hover:text-[#C9A14A] transition-colors">prateekgrewal@indravax.com</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-[#C9A14A]/15">
                    <div className="space-y-4">
                        <p className="text-xs text-slate-500 leading-relaxed font-light max-w-4xl">
                            <span className="text-slate-400 block mb-2 text-[0.7rem] tracking-[0.2em] uppercase">Regulatory Disclaimer</span>
                            Indravax Strategic Advisory LLP provides advisory and facilitation services. The firm
                            does not undertake any activity requiring regulatory approval without obtaining the
                            necessary licenses, permissions, or authorizations as required under applicable laws.
                        </p>
                        <p className="text-xs text-slate-500 leading-relaxed font-light max-w-4xl">
                            Indravax Strategic Advisory LLP operates as an independent advisory firm providing
                            strategic and transaction support services. All activities are conducted in compliance
                            with applicable laws and regulatory requirements.
                        </p>
                    </div>
                    <div className="mt-6 flex flex-col sm:flex-row justify-between gap-4 text-[0.7rem] tracking-[0.2em] uppercase text-slate-500">
                        <span>© {new Date().getFullYear()} Indravax Strategic Advisory LLP · All Rights Reserved</span>
                        <span>Independent · Advisory · Cross-Border</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
